//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'albumList',
    data() {
        const vm = this;
        return {
            loading: false,
            saving: false,
            name: '',
            columns: [
                {
                    type: 'index',
                    width: 60,
                    align: 'center'
                },
                {
                    key: 'name',
                    title: '相册名称',
                    render: (h, params) => {
                        const row = params.row;
                        const actions = [];
                        actions.push(h('a', {
                            on: {
                                click() {
                                    vm.albumsDetail(row);
                                }
                            }
                        }, row.name));
                        return h('div', actions);
                    }
                },
                // {
                //     key: 'businessTypeStr',
                //     title: '类型'
                // },
                {
                    key: 'uploaderName',
                    title: '创建人'
                },
                {
                    key: 'description',
                    title: '相册简介'
                },
                {
                    key: 'actions',
                    title: '操作',
                    width: 170,
                    align: 'center',
                    render(h, params) {
                        const row = params.row;
                        const actions = [];
                        if (vm.hasPermission('Pages.ActivityManage.Album.Edit')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                on: {
                                    click: function() {
                                        vm.editAlbum(row);
                                    }
                                }
                            }, '编辑'));
                        }
                        if (vm.hasPermission('Pages.ActivityManage.Album.Delete')) {
                            actions.push(h('Button', {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                style: {
                                    marginLeft: '5px'
                                },
                                on: {
                                    click() {
                                        vm.delAlbum(row);
                                    }
                                }
                            }, '删除'));
                        }
                        return h('div', actions);
                    }
                }
            ],
            searchInput: {},
            showEditAlbumModel: false,
            rules: {
                name: [{ required: true, message: '请输入相册名称', trigger: 'blur' }]
            },
            album: {},
            tags: ['亲子', '旅游', '家园', '物业', '运动', '美景'],
            count: []
        };
    },
    methods: {
        pageChange(page) {
            this.$store.commit('album/setCurrentPage', page);
            this.getPage();
        },
        pageSizeChange(pageSize) {
            this.$store.commit('album/setPageSize', pageSize);
            this.getPage();
        },
        getPage() {
            this.loading = true;
            this.$store.dispatch({
                type: 'album/getAlbumAll',
                data: this.searchInput
            }).finally(() => {
                this.loading = false;
            });
        },
        editAlbum(album) {
            // let parames = {
            //     id: album.id,
            //     businessId: album.businessId,
            //     businessType: album.businessType
            // };
            // this.$router.push({
            //     path: '/albumsEdit/' + JSON.stringify(parames)
            // });
            this.album = album;
            this.showEditAlbumModel = true;
        },
        delete(album) {
            this.$store.dispatch({
                type: 'album/delAlbum',
                id: album.id
            }).then(() => {
                this.$Notice.success({
                    duration: 3,
                    title: album.name + '已删除'
                });
                this.getPage();
            });
        },
        delAlbum(album) {
            this.$Modal.confirm({
                title: '删除确认',
                content: '您确定要删除' + album.name + '吗？',
                onOk: () => {
                    this.delete(album);
                },
                onCancel: () => {
                }
            });
        },
        albumsDetail(row) {
            this.$router.push({
                path: '/albumsDetail/' + row.id
            });
        },
        onSave() {
            this.album.tag = this.count.toString();
            this.$refs.albumForm.validate(async (val) => {
                this.saving = true;
                abp.ajax.post('/api/services/app/Album/SaveAlbum', this.album).then(res => {
                    this.saving = false;
                    this.showEditAlbumModel = false;
                    this.albumsDetail({ id: res.data.result });
                }, (error) => {
                    this.saving = false;
                });
            });
        },
        handleAdd(name) {
            // if (this.count.length) {
            //     this.count.push(this.count[this.count.length - 1] + 1);
            // } else {
            //     this.count.push(0);
            // }
            if (!this.count.includes(name)) {
                this.count.push(name);
            }
        },
        handleClose2(event, name) {
            const index = this.count.indexOf(name);
            this.count.splice(index, 1);
        },
        hasPermission(permission) {
            return abp.auth.isGranted(permission);
        }
    },
    computed: {
        albums() {
            return this.$store.state.album.albums;
        },
        totalCount() {
            return this.$store.state.album.totalCount;
        },
        currentPage() {
            return this.$store.state.album.currentPage;
        },
        pageSize() {
            return this.$store.state.album.pageSize;
        }
    },
    created() {
        this.getPage();
    }
};
